<template>
    <div class="page-404">

        <div class="content">
            <div class="icon"></div>

            <div class="text">
                <div class="title">Страница не найдена</div>
                <div class="desc">
                    Возможно, вы перешли по ссылке, в которой была допущена ошибка, <br> или ресурс был удален.
                    Попробуйте перейти на
                    <router-link :to="{ name: 'home' }" class="accent">главную страницу</router-link>
                </div>
            </div>
        </div>
    </div>
</template>

<script>


export default {
    name: 'Page404',

};
</script>

<style lang="scss" scoped>
@import "@dsee/mixins";

.page-404 {
    height: calc(100vh - (var(--footer-height) + var(--header-height)));
    display: flex;

    .content {
        margin: auto;
    }

    .icon {
        background-image: url('./icons/404.png');
        background-size: contain;
        @include icon(418px, 177px);
        cursor: default;
    }

    .text {
        margin-top: 20px;
        text-align: center;

        .title {
            font-size: 16px;
            font-weight: 700;
            line-height: 22px;
        }

    }

}
</style>
